module.exports = __webpack_public_path__ + "img/database.26ce0604.svg";